import { computed, ref } from 'vue';
import { useWindowSize } from '@vueuse/core';
import { useUISettings } from 'dashboard/composables/useUISettings';
import wootConstants from 'dashboard/constants/globals';

export function useIsMobile() {
  const { width } = useWindowSize();
  return computed(() => width.value < wootConstants.MOBILE_SCREEN_BREAKPOINT);
}

// On phones the contact panel covers the conversation, so it starts closed and
// its state is not saved: is_contact_sidebar_open is a per-user setting shared
// with the desktop.
export function useContactPanel() {
  const { uiSettings, updateUISettings } = useUISettings();
  const isMobile = useIsMobile();
  const isMobilePanelOpen = ref(false);

  // Desktop passes the setting on as is: when it was never set, ConversationBox
  // shows the panel (its prop defaults to true)
  const isContactPanelOpen = computed(() =>
    isMobile.value
      ? isMobilePanelOpen.value
      : uiSettings.value.is_contact_sidebar_open
  );

  const toggleContactPanel = () => {
    if (isMobile.value) {
      isMobilePanelOpen.value = !isMobilePanelOpen.value;
    } else {
      updateUISettings({ is_contact_sidebar_open: !isContactPanelOpen.value });
    }
  };

  const closeMobileContactPanel = () => {
    isMobilePanelOpen.value = false;
  };

  return { isContactPanelOpen, toggleContactPanel, closeMobileContactPanel };
}
